<template>

  <vx-card>

    <div class="vx-row">
      <div class="vx-col w-full inline-flex">
        <h5> {{ $t('class-section.vdo-set-info') }} </h5>
      </div>
    </div>

    <vs-divider/>

    <div class="vx-row mb-3">
      <div class="vx-col w-full">
        <ValidationProvider :name="$t('class-section.vdo-sets')" rules="required" v-slot="{ errors }">
          <v-select :dir="$vs.rtl ? 'rtl' : 'ltr'" :name="$t('class-section.vdo-sets')"
                    :options="vdoSets" class="w-full mb-1"
                    label="code"
                    selectOnTab
                    v-model="local.classSectionEdit.selectedClassSection.vdoSet">

            <template #selected-option="{ code }">
              {{ code }}
            </template>
            <!--option list-->
            <template v-slot:option="option">
              {{ option.code + ' ' + option.description}}
            </template>

          </v-select>
          <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
        </ValidationProvider>
      </div>
    </div>

    <div class="vx-row mb-3">
      <div class="vx-col sm:w-1/2">
        <span class="flex items-center">
          <feather-icon icon="BookOpenIcon" svgClasses="h-5 w-5 stroke-current text-primary"></feather-icon>
          <span class="ml-2 inline-block font-semibold">{{ $t('class-room.course-outline-units-qty') }}</span>
        </span>
      </div>
      <div class="vx-col sm:w-1/2 text-right">
        <span :class="totalVdoUnits === 0 ? 'text-danger':''">
          {{ totalVdoUnits }}
        </span>
      </div>
    </div>
    <div class="vx-row mb-3">
      <div class="vx-col sm:w-1/2">
        <span class="flex items-center">
          <feather-icon icon="VideoIcon" svgClasses="h-5 w-5 stroke-current text-primary"></feather-icon>
          <span
            class="ml-2 inline-block font-semibold">{{ $t('class-room.course-outline-vdo-sets-qty') }}</span>
        </span>
      </div>
      <div class="vx-col sm:w-1/2 text-right">
        <span :class="totalVdoQty === 0 ? 'text-danger':''">
          {{ totalVdoQty }}
        </span>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <span class="flex items-center">
          <feather-icon icon="FilmIcon" svgClasses="h-5 w-5 stroke-current text-primary"></feather-icon>
          <span
            class="ml-2 inline-block font-semibold">{{ $t('class-room.course-outline-vdo-sets-total-length') }}</span>
        </span>
      </div>
      <div class="vx-col sm:w-1/2 text-right">
        <span :class="totalVdoLength === '00:00:00' ? 'text-danger':''">
          {{ totalVdoLength }}
        </span>
      </div>
    </div>

  </vx-card>

</template>

<script>
  import {state} from '../data';
  import vSelect from 'vue-select';
  import {secondToHHMMSSFormat} from "@/utils/data";
  import {hasVideo} from "@/utils/video-source";

  import VdoSet from '@/store/modules/vdo-set/vdo-set/index';
  import {createNamespacedHelpers} from "vuex";
  import {createHelpers} from "vuex-map-fields";

  if (!state.store.VdoSet) state.registerModule(`VdoSet`, VdoSet);

  const {
    mapActions: mapVdoSetActions,
  } = createNamespacedHelpers(`VdoSet`);

  const {
    mapFields: mapVdoSetFields,
  } = createHelpers({
    getterType: `VdoSet/getField`,
    mutationType: `VdoSet/updateField`,
  });

  export default {
    components: {
      vSelect
    },
    data() {
      return {
        store: state.store,
        local: state.local,
      }
    },
    computed: {
      ...mapVdoSetFields({VdoSetProcessing: 'processing'}),
      totalVdoUnits() {
        let totalVdoUnit = 0;
        if (this.local.classSectionEdit.selectedClassSection.vdoSet) {
          totalVdoUnit = this.local.classSectionEdit.selectedClassSection.vdoSet.vdoSetUnits.length
        }
        return totalVdoUnit;
      },
      totalVdoLength() {
        let totalVdoLength = '00:00:00';
        if (this.local.classSectionEdit.selectedClassSection.vdoSet) {
          totalVdoLength = secondToHHMMSSFormat(this.local.classSectionEdit.selectedClassSection.vdoSet.totalVdoLength);
        }
        return totalVdoLength;
      },
      // hasVideo, not vdoStreamPath: Bunny topics have no vdoStreamPath and
      // were being counted as no video at all.
      totalVdoQty() {
        let totalVdoQty = 0;
        if (this.local.classSectionEdit.selectedClassSection.vdoSet) {
          this.local.classSectionEdit.selectedClassSection.vdoSet.vdoSetUnits.forEach(vdoUnit => {
            if (vdoUnit.vdoSetTopics && vdoUnit.vdoSetTopics.length > 0) {
              vdoUnit.vdoSetTopics.forEach(vdoTopic => {
                totalVdoQty += hasVideo(vdoTopic) ? 1 : 0;
              })
            }
          });
        }
        return totalVdoQty;
      },
      vdoSets() {
        return this.local.vdoSetInfo.vdoSets;
      },
    },
    watch: {
      VdoSetProcessing(data) {
        this.local.isProcessing = data;
      },
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//
      ...mapVdoSetActions({
        getVdoSetsByFilter: 'getVdoSetsByFilter',
      }),
      //---------------------------------------- Local Function ------------------------------------------------------//
      async initData() {
        //get vdoSets
        if (this.local.vdoSetInfo.vdoSets || this.local.vdoSetInfo.vdoSets.length === 0) {
          let payload = {
            vdoSetFilterInput: {
              courseOutlineId: this.$route.params.courseOutlineId
            }
          }
          this.local.vdoSetInfo.vdoSets = await this.getVdoSetsByFilter(payload);
        }
      },
    },
    async mounted() {
      await this.initData();
    }
  }

</script>

<style scoped>

</style>
